import { openobserveLogs } from '@openobserve/browser-logs';
import { openobserveRum } from '@openobserve/browser-rum';

const environment = import.meta.env.VITE_APP_ENV || (import.meta.env.DEV ? 'development' : 'production');
const version = import.meta.env.VITE_SENTRY_RELEASE || 'unknown';

function isLabOrDev(): boolean {
  return environment === 'development' || environment === 'lab';
}

export function initOpenObserveRum() {
  const clientToken = import.meta.env.VITE_OPENOBSERVE_RUM_CLIENT_TOKEN;
  const applicationId = import.meta.env.VITE_OPENOBSERVE_RUM_APPLICATION_ID;
  const site = import.meta.env.VITE_OPENOBSERVE_RUM_SITE;
  const organizationIdentifier = import.meta.env.VITE_OPENOBSERVE_RUM_ORG_IDENTIFIER;

  if (!clientToken || !applicationId || !site || !organizationIdentifier) return;

  const sessionSampleRate = Number(import.meta.env.VITE_OPENOBSERVE_RUM_SESSION_SAMPLE_RATE) || (isLabOrDev() ? 100 : 10);
  const sessionReplaySampleRate = Number(import.meta.env.VITE_OPENOBSERVE_RUM_REPLAY_SAMPLE_RATE) || (isLabOrDev() ? 50 : 0);

  openobserveRum.init({
    applicationId,
    clientToken,
    site,
    organizationIdentifier,
    service: 'savaf-frontend',
    env: environment,
    version,
    insecureHTTP: import.meta.env.VITE_OPENOBSERVE_RUM_INSECURE_HTTP === 'true',
    apiVersion: import.meta.env.VITE_OPENOBSERVE_RUM_API_VERSION || 'v1',
    sessionSampleRate,
    sessionReplaySampleRate,
    defaultPrivacyLevel: 'mask-user-input',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    silentMultipleInit: true,
  });

  openobserveLogs.init({
    clientToken,
    site,
    organizationIdentifier,
    service: 'savaf-frontend',
    env: environment,
    version,
    insecureHTTP: import.meta.env.VITE_OPENOBSERVE_RUM_INSECURE_HTTP === 'true',
    apiVersion: import.meta.env.VITE_OPENOBSERVE_RUM_API_VERSION || 'v1',
    sessionSampleRate,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error', 'warn'],
    silentMultipleInit: true,
  });
}

export function setRumUser(user: { id: string; role?: string; curatorOrgId?: string }) {
  if (!openobserveRum.getInitConfiguration()) return;
  openobserveRum.setUser({
    id: user.id,
    ...(user.role && { role: user.role }),
    ...(user.curatorOrgId && { curatorOrgId: user.curatorOrgId }),
  });
}

export function clearRumUser() {
  if (!openobserveRum.getInitConfiguration()) return;
  openobserveRum.clearUser();
}
